import * as v from "valibot";
import { pageRequest, pageResponse } from "./paging.dto";
import { aliasField, authorInfoDto } from "./shared.dto";

export const MAX_BATCH_AUTHORS = 100;

export const listAuthorsRequest = {
  category: v.optional(v.pipe(v.string(), v.maxLength(64))),
  subcategory: v.optional(v.pipe(v.string(), v.maxLength(64))),
  ...pageRequest,
};

export const listAuthorsResponse = {
  authors: v.array(authorInfoDto),
  ...pageResponse,
};

export const batchGetAuthorsRequest = {
  aliases: v.pipe(v.array(aliasField), v.minLength(1), v.maxLength(MAX_BATCH_AUTHORS)),
};

export const batchGetAuthorsResponse = {
  authors: v.array(authorInfoDto),
};

export const followAuthorRequest = {
  alias: aliasField,
};
